<template>
    <div class="toolbar-panel">
        <div class="child-full">
            <RuMenuDropDown
                id="current-dep"
                name="dep-switcher"
                :asset="currentDep.asset"
                :text="currentDep.text"
                :assetClass="currentDep.assetClass"
                :items="listDep"
                @itemClick="onDepItemClick"
            />
        </div>
        <div class="child-half">
            <RuMenuDropDown
                id="current-app"
                name="app-switcher"
                :asset="currentApp.asset"
                :text="currentApp.text"
                :assetClass="currentApp.assetClass"
                :items="listApp"
                @itemClick="onAppItemClick"
            />
            <RuMenuDropDown
                id="user-command"
                name="userCommand"
                :asset="fioAsset"
                :assetClass="currentApp.assetClass"
                :text="fio"
                :items="itemsCommand"
                @itemClick="onUserCommandClick"
            />
            <button :title="periodHint">
                {{ period }}
            </button>
            <button class="ai-version" :title="appData">
                {{ version }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ToolBarPanel',
};
</script>

<script setup>
import { onMounted, ref, computed } from 'vue';
import RuMenuDropDown from '@/components/RuMenuDropDown.vue';
import { getAppVersion } from '@/service/meta-service';

const version = ref('');

onMounted(async () => {
    const res = await getAppVersion();
    version.value = res.version;
});

const emit = defineEmits(['dep-changed', 'app-changed', 'user-command-click']);

const appData = computed(() => {
    return `АСУСЭ - Автоматизированная Система Управления Сбытом Энергии
Версия ${version.value}
Год разработки - 2024г
Разработчик: ООО "АЛЬФА-ИНТЕГРАТОР-ИНФОЭНЕРГО"`;
});

defineProps({
    currentDep: {
        type: Object,
        default: () => {
            return {};
        },
    },
    listDep: {
        type: Array,
        default: () => {
            return [];
        },
    },
    currentApp: {
        type: Object,
        default: () => {
            return {};
        },
    },
    listApp: {
        type: Array,
        default: () => {
            return [];
        },
    },
    fio: {
        type: String,
        default: () => {
            return '';
        },
    },
    fioAsset: {
        type: String,
        default: () => {
            return '';
        },
    },
    itemsCommand: {
        type: Array,
        default: () => {
            return [];
        },
    },
    period: {
        type: String,
        default: () => {
            return '';
        },
    },
    periodHint: {
        type: String,
        default: () => {
            return '';
        },
    },
    versionHint: {
        type: String,
        default: () => {
            return '';
        },
    },
});

// const onDropdownOpening = name => {
//     // if (name === 'dropdown-1') {
//     //   dropdown2.value.closeDropdown()
//     // } else {
//     //   dropdown1.value.closeDropdown()
//     // }
//     // emit('dropdown-opening')
// };
const onDepItemClick = item => {
    emit('dep-changed', item);
};

const onAppItemClick = item => {
    emit('app-changed', item);
};

const onUserCommandClick = item => {
    emit('user-command-click', item);
};
</script>
<style scoped>
.toolbar-panel {
    display: flex;
    flex-direction: column;
}

.child-full {
}

.child-half {
    display: flex;
    flex-direction: row;
}
.ai-version {
    margin-left: 20px;
}
</style>
